import request from '@/axios'
import type { UserType } from './types'

interface RoleParams {
  roleName: string,
  roleId:string
}

export const loginApi = (data: UserType): Promise<IResponse<UserType>> => {
  // /mock/user/login
  // /api/api/back/user/login
  return request.post({ url: '/api/api/back/user/login', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  // /mock/user/loginOut
  // /api/api/back/user/loginOut
  return request.get({ url: '/api/api/back/user/loginOut' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  // /mock/role/list
  // /api/api/back/role/list
  return request.get({ url: '/api/api/back/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}
